import {
  Component,
  effect,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  signal,
  SimpleChanges,
} from '@angular/core';
import { ApiService } from '../../../services/api.service';

import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '@fan-shared/alert/alert.service';
import { AlertType } from '@fan-types/alert-class';

@Component({
  selector: 'verify-form',
  templateUrl: './verify-form.component.html',
  styleUrls: ['./verify-form.component.scss'],
  standalone: false,
})
export class VerifyFormComponent implements OnChanges, OnDestroy {
  @Input() emailInput = '';
  @Input() fromRoute = true;
  @Output() isVerified = new EventEmitter<boolean>();

  alertService = inject(AlertService);
  code = '';
  email = '';
  isVerificationSuccess = false;
  processing = false;
  countdown = signal(0);
  timer: any;

  constructor(
    private api: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.email = this.activatedRoute.snapshot.queryParams?.email ?? this.emailInput ?? '';

    effect(() => {
      if (this.countdown() === 0) {
        this.stopCountdown();
      }
    });
  }

  ngOnDestroy(): void {
    this.stopCountdown();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.emailInput?.currentValue) {
      this.email = changes.emailInput.currentValue;
    }
  }

  verifyAccount() {
    this.processing = true;
    const emailVerification = {
      code: this.code,
      email: this.email,
    };
    this.api.user.verify(emailVerification).subscribe(
      (res) => {
        this.processing = false;
        this.isVerificationSuccess = true;
      },
      (err) => {
        this.processing = false;
        this.alertService.open('auth.invalidEmailOrCode');
      }
    );
  }

  resendCode() {
    this.processing = true;
    this.api.user.resendCode(this.email).subscribe(
      () => {
        this.processing = false;
        this.countdown.set(60);
        this.startCountdown();
        this.alertService.open('auth.newCodeSent', {
          type: AlertType.Information,
        });
      },
      (err) => {
        this.processing = false;
        this.countdown.set(0);
        this.alertService.open('auth.noEmailFound');
      }
    );
  }

  redirectToLogin() {
    if (this.fromRoute) {
      this.router.navigate(['/login']);
    } else {
      this.isVerified.emit(true);
    }
  }

  startCountdown() {
    if (this.timer) return; // Prevent multiple intervals
    this.timer = setInterval(() => {
      this.countdown.update((value) => value - 1);
    }, 1000);
  }

  stopCountdown() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
